var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.5H5A1.5 1.5 0 003.5 3v11.5l4.5-4 4.5 4V3A1.5 1.5 0 0011 1.5z",
    stroke: "#FF7D6B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgIcnBookmark;